import {
  getESysName,
  SiteAllowStringValues,
} from "@inrange/building-manager-api-client/models-site";

const LABEL_MAP: Record<string, string> = {
  inserted_rows: "inserted",
  updated_rows: "updated",
  unchanged_rows: "unchanged",
};

const formatCounts = (counts: Record<string, number>) =>
  Object.entries(counts)
    .map(([key, value]) => `${value} ${LABEL_MAP[key] || key}`)
    .join(", ");

const DbRecordsWritten = ({
  dbRecordsWritten,
  esys,
}: {
  dbRecordsWritten: Record<string, Record<string, number>>;
  esys: SiteAllowStringValues["esys"];
}) => {
  const esysCount = Object.keys(esys).length;

  return (
    <div className="mt-2">
      <span className="fw-bold">DB records written</span>
      {Object.entries(dbRecordsWritten).map(([esysUuid, counts]) => {
        const esysEntry = Object.values(esys).find((e) => e.uuid === esysUuid);
        const esysName = esysEntry
          ? `Energy match${getESysName(esysCount, esysEntry)}`
          : esysUuid;
        return (
          <div key={esysUuid} className="text-muted">
            {esysCount > 1 && <>{esysName}: </>}
            {formatCounts(counts)}
          </div>
        );
      })}
    </div>
  );
};

export default DbRecordsWritten;
